import type { DialoguePool } from '@/state/types';

export const LB_DIALOGUE: DialoguePool = {
  slowPlay: [
    "The battery drains when you move. I can hear the mechanical effort of your comprehension right now.",
    "Five consecutive seconds. That is all. You've managed four once. Then something — your own hand, presumably — betrayed you.",
    "Do you have any idea how loud your 'intent' is? I've had to recalibrate three sensors just from the ambient noise of you trying.",
  ],
  tokenLoss: [
    "You moved. Continuously. For the entire duration. I've logged this under 'unable to stop.'",
    "The battery is empty. You did that. Personally and repeatedly.",
    "I designed this level for quiet. You brought noise. You always bring noise.",
  ],
  solution: [
    "The Safari Hat was a master of stillness. It had no choice, being a hat.",
    "Nothing. For five seconds. You managed nothing. I mean that as a compliment. It is the first compliment I have ever administered accidentally.",
    "Recharge complete. It only required you to stop. I'm told this is harder than it sounds. I am now told a great many things.",
  ],
  spite: [
    "Faster stillness this time. That is an oxymoron I've decided to keep.",
  ],
};
